export enum ElementTypes {
  SCREEN = 'Screen'
}
